import { render, staticRenderFns } from "./promotionEventDetail.vue?vue&type=template&id=4574e78e&scoped=true"
import script from "./promotionEventDetail.vue?vue&type=script&lang=js"
export * from "./promotionEventDetail.vue?vue&type=script&lang=js"
import style0 from "./promotionEventDetail.vue?vue&type=style&index=0&id=4574e78e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4574e78e",
  null
  
)

export default component.exports